import { render, staticRenderFns } from "./Landing2Footer.vue?vue&type=template&id=12035702&scoped=true"
import script from "./Landing2Footer.vue?vue&type=script&lang=js"
export * from "./Landing2Footer.vue?vue&type=script&lang=js"
import style0 from "./Landing2Footer.vue?vue&type=style&index=0&id=12035702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12035702",
  null
  
)

export default component.exports